import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pageWidth: document.body.clientWidth,
    isMobile: document.body.clientWidth < 1320,
  },
  mutations: {
    SET_pageWidth: (state, val) => {
      state.pageWidth = val;
    },
    SET_isMobile: (state, val) => {
      state.isMobile = val;
    },
  },
  actions: {},
  modules: {},
});
